import isSuggestedRepliesEnabled from '../selectors/isSuggestedRepliesEnabled';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';

export default function isUndoSendOptionDirty(): boolean {
    const userConfiguration: OwaUserConfiguration = getUserConfiguration();
    const userOptions: UserOptionsType = userConfiguration && userConfiguration.UserOptions;

    if (userOptions) {
        return isSuggestedRepliesEnabled() !== userOptions.WebSuggestedRepliesEnabledForUser;
    } else {
        // If user options does not exist, just assume not dirty.
        return false;
    }
}
